import type { IOverleveringChecklistReport } from "./901Schema.js";

/** Completion measures answered questions, not whether all requirements are met.
 * Uavklart is processed but still unresolved. Sections and comments do not affect progress.
 */
export const get901Stats = (report: IOverleveringChecklistReport | null | undefined) => {
  const counts = { yes: 0, no: 0, notRelevant: 0, unclear: 0, unanswered: 0 };
  for (const row of report?.rows ?? []) {
    if (row.kind !== "QUESTION") continue;
    switch (row.answer) {
      case "JA":
        counts.yes++;
        break;
      case "NEI":
        counts.no++;
        break;
      case "IR":
        counts.notRelevant++;
        break;
      case "UAVKLART":
        counts.unclear++;
        break;
      default:
        counts.unanswered++;
    }
  }
  const total = Object.values(counts).reduce((sum, count) => sum + count, 0);
  const resolved = counts.yes + counts.no + counts.notRelevant;
  const processed = resolved + counts.unclear;
  const percent = (count: number) => (total === 0 ? 0 : (count / total) * 100);
  return {
    total,
    counts,
    resolved,
    processed,
    completionPercent: Math.round(percent(resolved)),
    processedPercent: Math.round(percent(processed)),
    percentages: {
      yes: percent(counts.yes),
      no: percent(counts.no),
      notRelevant: percent(counts.notRelevant),
      unclear: percent(counts.unclear),
      unanswered: percent(counts.unanswered),
    },
  };
};
export type Stats901 = ReturnType<typeof get901Stats>;
